import React, { useEffect, useState } from "react";
import { Form } from "reactstrap";

import useCurrentCustomerStore from "stores/CustomerStore";
import ChildrenModal from "components/modals/ChildrenModal";
import InputElement, {
	CheckBoxElement,
	ZipInputElement2,
} from "../../../../forms/components/InputElement";
import InputWrapper from "../../../../forms/components/InputWrapper";
import MailingAddress from "./MailingAddress";
import ZipCityTable from "components/tables/ZipCityTable";

import { stateOptions, ownershipType, CountryCodes } from "constants/Constants";
import { useFormContext } from "react-hook-form";
import {
	SelectorElement,
	CurrencyInputElement,
} from "../../../../forms/components/InputElement";
import dayjs from "dayjs";

const CurrentAddress = ({ getCities }) => {
	const [mailCityModal, setMailCityModal] = useState(false);
	const [mailAddressData, setMailAddressData] = useState({});
	const [checkAddress, setCheckAddress] = useState(false);

	const {
		street,
		currentAddress,
		mailingAddress,
		editMailingAddress,
		editCurrentAddressValue,
	} = useCurrentCustomerStore((state) => ({
		currentAddress: state.currentAddress,
		mailingAddress: state.mailingAddress,
		editMailingAddress: state.editMailingAddress,
		editCurrentAddressValue: state.editCurrentAddressValue,
	}));

	const isInternational =
		currentAddress.country && currentAddress.country !== "USA";
	const zipLabel = isInternational ? "Postal Code" : "Zip";
	const countyLabel = isInternational ? "Province/Governorate" : "County";

	const toggleMailCityModal = () => setMailCityModal(!mailCityModal);

	const handleMailZipChange = (zip, address) => {
		setMailAddressData({ zip, address });
		toggleMailCityModal();
	};

	const handleCurrentZipChange = (zip) => {
		console.log({ country: methods.getValues("currentCountry") });

		const updatedAddress = {
			...currentAddress,
			street: methods.getValues("currentStreet"),
			unit: methods.getValues("currentUnit"),
			city: methods.getValues("currentCity"),
			state: isInternational ? "" : methods.getValues("currentState"),
			zip: methods.getValues("currentZip"),
			county: methods.getValues("currentCounty"),
			country: currentAddress.country || "USA",
			fromDate: methods.getValues("currentFromDate"),
			ownership: methods.getValues("currentOwnership"),
			months: methods.getValues("currentMonth"),
			years: methods.getValues("currentYear"),
			monthlyPayment: methods.getValues("currentMonthlyPayment"),
		};

		getCities(zip, updatedAddress);
		console.log(updatedAddress);
	};

	const equalsValue = (a, b) => a != null && a !== "" && a === b;

	useEffect(() => {
		calculateYearsAndMonths();
		// eslint-disable-next-line
	}, [currentAddress.fromDate]);

	useEffect(() => {
		const allMatch =
			equalsValue(currentAddress?.street, mailingAddress?.street) &&
			equalsValue(currentAddress?.unit, mailingAddress?.unit) &&
			equalsValue(currentAddress?.city, mailingAddress?.city) &&
			equalsValue(currentAddress?.state, mailingAddress?.state) &&
			equalsValue(currentAddress?.zip, mailingAddress?.zip) &&
			equalsValue(currentAddress?.county, mailingAddress?.county) &&
			equalsValue(currentAddress?.country, mailingAddress?.country);

		if (allMatch) {
			setCheckAddress(true);
		}
		// eslint-disable-next-line
	}, []);

	const calculateYearsAndMonths = () => {
		if (currentAddress.fromDate) {
			const totalMonths = dayjs().diff(currentAddress.fromDate, "month");
			const years = Math.floor(totalMonths / 12);
			const months = totalMonths % 12;

			editCurrentAddressValue({
				months,
				years,
			});
		}
	};

	// Calculate fromDate from years and months (backwards calculation)
	const calculateFromDate = (years, months) => {
		const totalMonths = (parseInt(years) || 0) * 12 + (parseInt(months) || 0);
		const fromDate = dayjs().subtract(totalMonths, "month").format("YYYY-MM-DD");
		editCurrentAddressValue({
			fromDate,
			years: parseInt(years) || 0,
			months: parseInt(months) || 0,
		});
	};

	const methods = useFormContext();

	return (
		<div>
			<Form>
				<InputWrapper
					formTitle="Address"
					inputComponents={[
						<SelectorElement
							{...methods}
							value={currentAddress.ownership || ""}
							name="currentOwnership"
							label="Ownership"
							onChange={(e) =>
								editCurrentAddressValue({
									ownership: e.target.value,
								})
							}
							options={ownershipType}
						/>,
						<InputElement
							{...methods}
							value={currentAddress.fromDate || ""}
							onBlur={calculateYearsAndMonths}
							onChange={(e) =>
								editCurrentAddressValue({
									fromDate: e.target.value,
								})
							}
							name="currentFromDate"
							label="From Date"
							type="date"
						/>,
						<InputElement
							{...methods}
							value={currentAddress.years || ""}
							onChange={(e) =>
								calculateFromDate(e.target.value, currentAddress.months)
							}
							name="currentYear"
							label="Years"
							type="number"
						/>,
						<InputElement
							{...methods}
							value={currentAddress.months || ""}
							onChange={(e) =>
								calculateFromDate(currentAddress.years, e.target.value)
							}
							name="currentMonth"
							label="Months"
							type="number"
						/>,
						<InputElement
							{...methods}
							value={currentAddress.street || ""}
							onChange={(e) =>
								editCurrentAddressValue({
									street: e.target.value,
								})
							}
							name="currentStreet"
							label="Street Address"
							type="text"
						/>,
						<InputElement
							{...methods}
							value={currentAddress.unit || ""}
							onChange={(e) =>
								editCurrentAddressValue({
									unit: e.target.value,
								})
							}
							name="currentUnit"
							label="Apt/Unit/Bld"
							type="text"
						/>,
						<InputElement
							{...methods}
							value={currentAddress.city || ""}
							onChange={(e) =>
								editCurrentAddressValue({
									city: e.target.value,
								})
							}
							name="currentCity"
							label="City"
							type="text"
						/>,
						<SelectorElement
							{...methods}
							value={currentAddress.country || "USA"}
							onChange={(e) =>
								editCurrentAddressValue({
									country: e.target.value,
								})
							}
							name="currentCountry"
							label="Country"
							options={CountryCodes}
						/>,
						!isInternational && (
							<SelectorElement
								{...methods}
								value={currentAddress.state || ""}
								name="currentState"
								label="State"
								onChange={(e) =>
									editCurrentAddressValue({
										state: e.target.value,
									})
								}
								options={stateOptions}
							/>
						),
						<ZipInputElement2
							{...methods}
							value={currentAddress.zip || ""}
							onChange={(zip) =>
								editCurrentAddressValue({
									zip,
								})
							}
							openZipModal={handleCurrentZipChange}
							name="currentZip"
							label={zipLabel}
							isInternational={isInternational}
						/>,
						<InputElement
							{...methods}
							value={currentAddress.county || ""}
							onChange={(e) =>
								editCurrentAddressValue({
									county: e.target.value,
								})
							}
							name="currentCounty"
							label={countyLabel}
							type="text"
						/>,
						<CurrencyInputElement
							{...methods}
							value={currentAddress.monthlyPayment || ""}
							onChange={(val) =>
								editCurrentAddressValue({
									monthlyPayment: val,
								})
							}
							name="currentMonthlyPayment"
							label="Rent/Mortgage"
							type="text"
						/>,
						<CheckBoxElement
							{...methods}
							checked={checkAddress}
							onChange={() => setCheckAddress(!checkAddress)}
							name="sameAsMailing"
							label="Mailing Address Same as Current Address"
							labelClass="pl-4 required"
						/>,
					]}
				/>
			</Form>
			<br />
			<div>
				<MailingAddress
					getMailCities={handleMailZipChange}
					sameAsCurrent={checkAddress}
				/>
				<ChildrenModal
					modal={mailCityModal}
					toggle={toggleMailCityModal}
					modalTitle="Cities"
				>
					<ZipCityTable
						data={mailAddressData}
						toggle={toggleMailCityModal}
						address={mailingAddress}
						setAddress={editMailingAddress}
					/>
				</ChildrenModal>
			</div>
		</div>
	);
};

export default CurrentAddress;
